<template>
  <page-list
    :list="list"
    :columns="columns"
    :single-actions="singleActions"
    :group-actions="groupActions"
    :export-data-options="exportDataOptions">
    <template v-slot:group-actions-append>
      <a-button class="ml-2" @click="pullBill">{{$t('bill.pull_bill_by_policy')}}</a-button>
    </template>
  </page-list>
</template>

<script>
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'
import {
  getNameFilter,
  getCreatedAtFilter,
} from '@/utils/common/tableFilter'
import SingleActionMixin from '../mixins/singleActions'
import ColumnsMixin from '../mixins/columns'

export default {
  name: 'CostconversionList',
  mixins: [WindowsMixin, ListMixin, ColumnsMixin, SingleActionMixin],
  props: {
    id: String,
  },
  data () {
    return {
      timer: null,
      list: this.$list.createList(this, {
        id: this.id,
        resource: 'cost_conversions',
        apiVersion: 'v1',
        getParams: this.getParams,
        filterOptions: {
          name: getNameFilter(),
          created_at: getCreatedAtFilter(),
          user_rule_type: {
            field: 'user_rule_type',
            title: this.$t('bill.policy_type'),
            dropdown: true,
            items: [
              { key: 'resource', label: this.$t('bill.resource_policy') },
              { key: 'global', label: this.$t('bill.global_policy') },
            ],
          },
        },
        hiddenColumns: ['currency_applied', 'created_at'],
      }),
      groupActions: [
        {
          label: this.$t('bill.text_193'),
          permission: 'cost_conversions_create',
          action: () => {
            this.$router.push({
              path: '/cost-conversion/create',
            })
          },
          meta: () => {
            return {
              buttonType: 'primary',
            }
          },
        },
        {
          label: this.$t('common.delete'),
          permission: 'cost_conversions_delete',
          action: () => {
            const data = this.list.selectedItems
            this.createDialog('DeleteResDialog', {
              vm: this,
              data,
              columns: this.columns,
              title: this.$t('common.delete'),
              name: this.$t('bill.cost_conversion'),
              onManager: this.onManager,
            })
          },
          meta: () => {
            return {
              validate: this.list.selectedItems.length > 0,
            }
          },
        },
      ],
      exportDataOptions: {
        items: [
          { label: this.$t('bill.text_88'), key: 'name' },
          { label: this.$t('bill.text_76'), key: 'domain_filter' },
          { label: this.$t('bill.policy_type'), key: 'type' },
          { label: this.$t('bill.text_162'), key: 'enable_date' },
          { label: this.$t('cloud_env.public'), key: 'is_public_cloud' },
          { label: this.$t('bill.text_81'), key: 'brand' },
          { label: this.$t('bill.text_60'), key: 'cloudaccount_name' },
          { label: this.$t('bill.text_233'), key: 'cloudprovider_name' },
          { label: this.$t('bill.cost_conversion_ratio'), key: 'ratio' },
          { label: this.$t('bill.text_185'), key: 'user_rules' },
          { label: this.$t('common.createdAt'), key: 'created_at' },
        ],
      },
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    fetchData () {
      this.list.fetchData()
    },
    handleOpenSidepage (row) {
      this.sidePageTriggerHandle(this, 'CostconversionSidePage', {
        id: row.id,
        resource: () => {
          return {
            data: row,
          }
        },
      }, {
        list: this.list,
      })
    },
    async pullBill () {
      this.createDialog('BillPullBillingDialog', {
        // ok: () => {
        //   this.getBillRewriteStatus()
        // },
      })
    },
  },
}
</script>
